import AV from 'leancloud-storage'

export const Quote = AV.Object.extend('Author')

Quote.getQuotes = function ({
  authorId,
  kind,
  dynasty,
  collectionId
}, page = 1, perPage = 10) {
  return AV.Cloud.rpc('getQuotes', {
    authorId,
    kind,
    dynasty,
    collectionId,
    page,
    perPage,
  })
}

Quote.getQuotesIncludeCount = function ({
  authorId,
  kind,
  dynasty,
  collectionId
}, page = 1, perPage = 10) {

  return AV.Cloud.rpc('getQuotesIncludeCount', {
    authorId,
    kind,
    dynasty,
    collectionId,
    page,
    perPage,
  }).then(({count, quotes}) => {
    return {
      pageCount: count % perPage === 0 ? count / perPage : ((count / perPage >> 0) + 1),
      quotes
    }
  })
}




// WEBPACK FOOTER //
// ./src/models/quote.js